import { BreakpointsMinQuery } from '@ab-core/breakpoints';
import { Colors } from '@ab-core/colors';
import { RADIUS } from '@ab-core/radius';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const BoxDivider = styled.div`
    width: 1.5rem;
`;

export const Border = styled.div`
    width: 100%;
    position: relative;
    background-color: white;
    padding: ${SPACING.MEDIUM};
    border: 1px solid ${Colors.gray30};
    border-radius: ${RADIUS.ROUNDED};
    margin: ${SPACING.SMALL_2} 0;
`;

export const Content = styled.div`
    width: 100%;
    @media ${BreakpointsMinQuery.lg} {
        display: flex;
        justify-content: flex-start;
    }
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${Colors.gray15};
    margin: ${SPACING.SMALL_3}0;
`;

export const Block = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Colum = styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: ${SPACING.SMALL};
`;

export const ScaleColumn = styled.div`
    display: flex;
    align-items: center;
    gap: ${SPACING.SMALL_2};
`;
